const global = () => {}

global.EVENT_CARD_MIN_WIDTH = '16rem'
global.SIDE_PADDING = 7

export default global
